import {Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { DateTime } from 'luxon';
import { AlarmGeneratedResolvedInterface } from 'src/app/models/common/device-telemetry-model';

@Pipe({
  name: 'customDate',
  standalone: true
})
export class CustomDatePipe implements PipeTransform {
  transform(value?: string, ...args: AlarmGeneratedResolvedInterface[]): unknown {
    if(!value){
        return null
    }
    const formatedDay = formatDate(value,'d', 'en-US')
    const formatedYear = formatDate(value,'y', 'en-US')
    const formattedMonth =  formatDate(value,'MMMM', 'en-US')
    let d = new Date(value)
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)
    const isToday = (d.getFullYear() == today.getFullYear() && d.getMonth() == today.getMonth() && d.getDate() == today.getDate())
    const isYesterday = (d.getFullYear() == yesterday.getFullYear() && d.getMonth() == yesterday.getMonth() && d.getDate() == yesterday.getDate())

    if(args[0]){
        const isResolvedTime = args[0].isAlarmGenerated
        const timeZOne = args[0].timeZone
        const convertedTime = timeZOne ? this.convertToLocalTime(value,timeZOne):""
        return this.alarmResolvedTimeDisplay(convertedTime,today,isToday,formatedDay,formatedYear,formattedMonth,isResolvedTime)
    }
    const alarmMessage = isToday ?  "Today":
                          isYesterday ? "Yesterday": formatDate(value,'EEEE', 'en-US')
    return `${alarmMessage} ${formattedMonth} ${formatedDay} ${formatedYear}`
    
  }

    convertToLocalTime(utcTime: string, zone: string): string {
      const formattedTime = utcTime.split('.')[0] + 'Z'
      const newFormattedTime = formattedTime.replace(" ","T")
      return DateTime.fromISO(newFormattedTime, { zone: 'utc' })
                     .setZone(zone)
                     .toFormat('yyyy-MM-dd HH:mm:ss');
    }

    alarmResolvedTimeDisplay(time:string,date:Date,isToday:boolean,formatedDay:string,formatedYear:string,formattedMonth:string,isResolvedTime:boolean){
        const alarmGeneratedOrResolved = new Date(time);
        let resolvedString:string = ""
        if (!isResolvedTime){
            resolvedString = `${formattedMonth} ${formatedDay} ${formatedYear}`
        }
        if(isToday ){
        const diffTime = Math.abs(Number(date) - Number(alarmGeneratedOrResolved));
        const diffTimeList =  (diffTime / (3_600_000)).toFixed(2).split(".")
        const hours = diffTimeList[0]
        const minutes:number = Number(diffTimeList[1])
        const minute = (((minutes) * 60)/100).toFixed(0)
        return `${hours} hours and ${minute} minutes ago`
        }
        return `${alarmGeneratedOrResolved.toLocaleString('en-US', { hour: 'numeric',minute:'numeric',hour12: true })} ${resolvedString}`;


    }

}
